module.exports = __webpack_public_path__ + "2332bf091d06c1a0f99fc9555aa8c0cd.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/sites/ride/logo.svg
// module id = 242
// module chunks = 1